export default __webpack_public_path__ + "static/media/statsPie.3cc1f7df.svg";